export default __webpack_public_path__ + "static/media/card-success.b6634da7.png";